import { makeRequest } from './data_utils';

const getTrainingSet = (trainingId) => {
    const endpoint = `api/coach/training/${trainingId}/complete`;
    return makeRequest(endpoint, 'GET');
};

const trainingData = {
    getTrainingSet
};

export { trainingData }; 